import React from 'react';
import styled from 'styled-components';

const PageWrapper = styled.div`
  width: 100%;
  contain: layout style paint;
`;

interface PageTransitionProps {
  children: React.ReactNode;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  return (
    <PageWrapper>
      {children}
    </PageWrapper>
  );
};

export default React.memo(PageTransition);